import React from "react";
import AdminSidebar from "../Admin/AdminSidebar";
import { Outlet } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  return (
    <div className="flex h-full min-h-screen">
      <AdminSidebar />
      <main className="flex-1 p-6 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminDashboard;
